<template>
    <div class="popup" v-show="visible">
        <div class="content">
            <a href="" class="close icon-close" @click.prevent="close"></a>

            <slot />
        </div>
    </div>
</template>

<script async setup lang="ts">

const { visible = false } = defineProps<{ visible: boolean }>();

const emit = defineEmits(["update:visible"]);

function close() {
    emit("update:visible", false);
}

</script>
